import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { debug } from "@/utils/debug/logger";

import { changeLanguage as changeLanguageUtil } from "./changeLanguage";

export type LanguageOption = {
  key: string;
  value: string;
};

export const useLanguage = () => {
  const { i18n } = useTranslation();

  const allLanguages: LanguageOption[] = useMemo(
    () => [
      { key: "et", value: "Eesti" },
      { key: "en", value: "English" },
      { key: "lv", value: "Latviešu" },
    ],
    [],
  );

  const currentLanguageKey = i18n.language;

  const currentLanguageLabel = useMemo(
    () => allLanguages.find((lang) => lang.key === currentLanguageKey)?.value || "English",
    [allLanguages, currentLanguageKey],
  );

  const setLanguage = useCallback(
    async (language: string) => {
      debug.log("useLanguage", `Changing language from ${i18n.language} to ${language}`);
      await changeLanguageUtil(language);
    },
    [i18n.language],
  );

  return {
    allLanguages,
    currentLanguageKey,
    currentLanguageLabel,
    setLanguage,
  };
};

export type UseLanguageReturn = ReturnType<typeof useLanguage>;
